import { IntegrationsTab } from '../models/enums';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Reuses the same component instance when navigating between route configs that share the
 * same component class and a common path prefix. This keeps state (selected service/route,
 * map markers, list scroll position, etc.) alive across path-level transitions, avoiding
 * the destroy/recreate flicker that the default strategy would cause.
 */
export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  private static readonly REUSE_PREFIXES = [
    'services',
    'bookings',
    'users',
    'drivers',
    'suggestions',
    'messages',
    'vehicles',
    'clients',
    ...Object.values(IntegrationsTab),
  ];

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (super.shouldReuseRoute(future, curr)) return true;

    if (future.routeConfig?.component !== curr.routeConfig?.component) return false;

    const futurePath = future.routeConfig?.path ?? '';
    const currPath = curr.routeConfig?.path ?? '';

    return CustomRouteReuseStrategy.REUSE_PREFIXES.some(prefix =>
      this.matchesPrefix(futurePath, prefix) && this.matchesPrefix(currPath, prefix)
    );
  }

  private matchesPrefix(path: string, prefix: string): boolean {
    return path === prefix || path.startsWith(`${prefix}/`);
  }
}
